module.exports = __webpack_public_path__ + "static/img/login_bg.cb167e50.png";